import { useMemo, useCallback } from "react";
import { Select } from "antd";
import { withLocale } from "../../l10n/index.jsx";

function FilterColumns({ lang, columns = [], selectedColumns = [], changeColumns }) {

  // ===== HELPERS =====
const normalizeDataIndex = (dataIndex) =>
  Array.isArray(dataIndex) ? dataIndex.join(".") : dataIndex;

  // ===== DERIVADOS =====
  const options = useMemo(() => {
    return columns.map((c) => ({
      label: c.title,
      value: normalizeDataIndex(c.dataIndex),
    }));
  }, [columns]);

  const selectedValues = useMemo(() => {
    return selectedColumns.map((c) => normalizeDataIndex(c.dataIndex));
  }, [selectedColumns]);

  // ===== HANDLERS =====
  const handleChange = useCallback(
    (selectedKeys) => {
      const result = columns.filter((c) =>
        selectedKeys.includes(normalizeDataIndex(c.dataIndex))
      );
      changeColumns(result);
    },
    [columns, changeColumns]
  );

  // ===== RENDER =====
  return (
    <div>
      <form>
        <label htmlFor="columns-select">
          {lang.handle("Columnas")}:
        </label>
        <Select
          id="columns-select"
          mode="multiple"
          allowClear
          style={{ width: "80%" }}
          onChange={handleChange}
          value={selectedValues}
          options={options}
          maxTagCount={5}
          placeholder="Selecciona columnas..."
        />
      </form>
    </div>
  );
}

export default withLocale(FilterColumns);
